import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    loadGwSicherungsStatusListStatus: 'idle',
    loadGwSicherungsStatusListError: undefined as any,
    loadGwSicherungsStatusListLastArgs: undefined as any,
    loadGwSicherungsStatusStatus: 'idle',
    loadGwSicherungsStatusError: undefined as any,
    saveGwSicherungsStatusStatus: 'idle',
    saveGwSicherungsStatusError: undefined as any,
    deleteGwSicherungsStatusStatus: 'idle',
    deleteGwSicherungsStatusError: undefined as any,

    gwSicherungsStatusList: [] as any[],
    formItem: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const loadGwSicherungsStatusList = createAsyncThunk('gwSicherungsStatusSlice/loadGwSicherungsStatusList', async ({ forceReload }: any, { rejectWithValue, getState }: any) => {
    const lastArgs = getState().gwSicherungsStatusSlice.loadGwSicherungsStatusListLastArgs
    if (_.isEqual(lastArgs, {  }) && !forceReload) { return }

    let promises = []
    promises.push(client.get(
        `/api/ixweb/nurisgwsichstatus/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
        args: {  }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadGwSicherungsStatusListStatus } = getState().gwSicherungsStatusSlice
        return loadGwSicherungsStatusListStatus !== 'pending'
    }
})

export const loadGwSicherungsStatus = createAsyncThunk('gwSicherungsStatusSlice/loadGwSicherungsStatus', async ({ id }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/nurisgwsichstatus/?action=eql&HDR_ID=${id}`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: {
            ...value1,
        }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadGwSicherungsStatusStatus } = getState().gwSicherungsStatusSlice
        return loadGwSicherungsStatusStatus !== 'pending'
    }
})

export const saveGwSicherungsStatus = createAsyncThunk('gwSicherungsStatusSlice/saveGwSicherungsStatus', async ({ gwSicherungsStatus }: any, { rejectWithValue }: any) => {
    let promises = []
    if (gwSicherungsStatus?.HDR_ID) {
        promises.push(client.put(
            `/api/ixweb/nurisgwsichstatus/${ gwSicherungsStatus?.HDR_ID }/`,
            prepareData(gwSicherungsStatus),
        ))
    } else {
        promises.push(client.post(
            `/api/ixweb/nurisgwsichstatus/`,
            prepareData(gwSicherungsStatus),
        ))
    }

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: {
            ...value1,
        }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { saveGwSicherungsStatusStatus } = getState().gwSicherungsStatusSlice
        return saveGwSicherungsStatusStatus !== 'pending'
    }
})

export const deleteGwSicherungsStatus = createAsyncThunk('gwSicherungsStatusSlice/deleteGwSicherungsStatus', async ({ id }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.delete(
        `/api/ixweb/nurisgwsichstatus/${id}/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: id,
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { deleteGwSicherungsStatusStatus } = getState().gwSicherungsStatusSlice
        return deleteGwSicherungsStatusStatus !== 'pending'
    }
})

const GwSicherungsStatusSlice = createSlice({
    name: 'gwSicherungsStatusSlice',
    initialState,
    reducers: {
        resetloadGwSicherungsStatusListError: (state) => {
            state.loadGwSicherungsStatusListError = undefined
        },
        resetloadGwSicherungsStatus: (state) => {
            state.formItem = undefined
            state.loadGwSicherungsStatusError = undefined
        },
        resetloadGwSicherungsStatusError: (state) => {
            state.loadGwSicherungsStatusError = undefined
        },
        resetsaveGwSicherungsStatus: (state) => {
            state.formItem = undefined
            state.saveGwSicherungsStatusError = undefined
        },
        resetsaveGwSicherungsStatusError: (state) => {
            state.saveGwSicherungsStatusError = undefined
        },
        resetdeleteGwSicherungsStatusError: (state) => {
            state.deleteGwSicherungsStatusError = undefined
        },
        removeFromGwSicherungsStatusListById: (state, action) => {
            state.gwSicherungsStatusList = state.gwSicherungsStatusList.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromGwSicherungsStatusListByIds: (state, action) => {
            state.gwSicherungsStatusList = state.gwSicherungsStatusList.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.gwSicherungsStatusList = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.loadGwSicherungsStatusListStatus = 'preloaded'
            state.loadGwSicherungsStatusListLastArgs = ''
        },
        clearPreloadedData: (state) => {
            state.gwSicherungsStatusList = []
            state.loadGwSicherungsStatusListStatus = 'idle'
            state.loadGwSicherungsStatusListLastArgs = undefined
        },
    },
    extraReducers: builder => {
        builder.addCase(loadGwSicherungsStatusList.pending, (state) => {
            state.loadGwSicherungsStatusListStatus = 'pending'
            state.loadGwSicherungsStatusListError = undefined
        })
        builder.addCase(loadGwSicherungsStatusList.fulfilled, (state, action) => {
            state.loadGwSicherungsStatusListStatus = 'idle'

            if (!action.payload) { return }

            state.loadGwSicherungsStatusListLastArgs = action.payload.args

            {
                state.gwSicherungsStatusList = action.payload.data

            }
        })
        builder.addCase(loadGwSicherungsStatusList.rejected, (state, action) => {
            state.loadGwSicherungsStatusListStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadGwSicherungsStatusListError = action.error.message
            } else {
                state.loadGwSicherungsStatusListError = action.payload
            }
        })

        builder.addCase(loadGwSicherungsStatus.pending, (state) => {
            state.loadGwSicherungsStatusStatus = 'pending'
            state.loadGwSicherungsStatusError = undefined
        })
        builder.addCase(loadGwSicherungsStatus.fulfilled, (state, action) => {
            state.loadGwSicherungsStatusStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.formItem = newItem
            }
            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                const i = state.gwSicherungsStatusList.findIndex((x: any) => x.HDR_ID === newItem.HDR_ID)
                if (i === -1) { state.gwSicherungsStatusList.push(newItem) }
                else { state.gwSicherungsStatusList[i] = { ...state.gwSicherungsStatusList[i], ...newItem } }
            }
        })
        builder.addCase(loadGwSicherungsStatus.rejected, (state, action) => {
            state.loadGwSicherungsStatusStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadGwSicherungsStatusError = action.error.message
            } else {
                state.loadGwSicherungsStatusError = action.payload
            }
        })

        builder.addCase(saveGwSicherungsStatus.pending, (state) => {
            state.saveGwSicherungsStatusStatus = 'pending'
            state.saveGwSicherungsStatusError = undefined
        })
        builder.addCase(saveGwSicherungsStatus.fulfilled, (state, action) => {
            state.saveGwSicherungsStatusStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.formItem = newItem
            }
            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                const i = state.gwSicherungsStatusList.findIndex((x: any) => x.HDR_ID === newItem.HDR_ID)
                if (i === -1) { state.gwSicherungsStatusList.push(newItem) }
                else { state.gwSicherungsStatusList[i] = { ...state.gwSicherungsStatusList[i], ...newItem } }
            }
        })
        builder.addCase(saveGwSicherungsStatus.rejected, (state, action) => {
            state.saveGwSicherungsStatusStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.saveGwSicherungsStatusError = action.error.message
            } else {
                state.saveGwSicherungsStatusError = action.payload
            }
        })

        builder.addCase(deleteGwSicherungsStatus.pending, (state) => {
            state.deleteGwSicherungsStatusStatus = 'pending'
            state.deleteGwSicherungsStatusError = undefined
        })
        builder.addCase(deleteGwSicherungsStatus.fulfilled, (state, action) => {
            state.deleteGwSicherungsStatusStatus = 'idle'

            {
                if (Array.isArray(action.payload.data)) {
                    state.gwSicherungsStatusList = state.gwSicherungsStatusList.filter((x: any) => !action.payload.data.includes(x.HDR_ID))
                } else {
                    state.gwSicherungsStatusList = state.gwSicherungsStatusList.filter((x: any) => x.HDR_ID !== action.payload.data)
                }
            }
        })
        builder.addCase(deleteGwSicherungsStatus.rejected, (state, action) => {
            state.deleteGwSicherungsStatusStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.deleteGwSicherungsStatusError = action.error.message
            } else {
                state.deleteGwSicherungsStatusError = action.payload
            }
        })

    }
})

export const {
    resetloadGwSicherungsStatusListError,
    resetloadGwSicherungsStatus,
    resetloadGwSicherungsStatusError,
    resetsaveGwSicherungsStatus,
    resetsaveGwSicherungsStatusError,
    resetdeleteGwSicherungsStatusError,
    removeFromGwSicherungsStatusListById,
    removeFromGwSicherungsStatusListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = GwSicherungsStatusSlice.actions
export default GwSicherungsStatusSlice.reducer
